import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-580c814a")

_pushScopeId("data-v-580c814a")
const _hoisted_1 = { class: "main-bg" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_c_search_list = _resolveComponent("c-search-list")
  const _component_c_table = _resolveComponent("c-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_c_search_list, {
      inputList: _ctx.inputList,
      showNumber: 3,
      onOnSearch: _ctx.handleSearch,
      onOnReset: _ctx.handleReset
    }, null, 8, ["inputList", "onOnSearch", "onOnReset"]),
    _createVNode(_component_c_table, {
      dataSource: _ctx.tableConfig,
      onPageCurrentChange: _ctx.pageCurrentChange,
      onPageSizeChange: _ctx.pageSizeChange,
      class: "mt30"
    }, {
      state: _withId((scope) => [
        (scope.row.state === 1)
          ? (_openBlock(), _createBlock("span", _hoisted_2, "启用"))
          : (_openBlock(), _createBlock("span", _hoisted_3, "禁止"))
      ]),
      _: 1
    }, 8, ["dataSource", "onPageCurrentChange", "onPageSizeChange"])
  ]))
})